import {useNavigation} from '@react-navigation/native';
import * as React from 'react';
import {StyleProp, ViewStyle} from 'react-native';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../../../redux';
import {initialize} from 'redux-form';
import {requestContactChange} from '../../../../redux/actions/profile';
import {holderProfileSelector} from '../../../../redux/selectors/profile';
import {InputMaskTypes} from '../../../../shared/components/baseField';
import {EvenOddListItemContentFactoryProps} from '../../../../shared/components/evenOddList';
import {useModal} from '../../../../shared/components/modal';
import {RequestedOperationType} from '../../../../shared/models/api';
import {Forms} from '../../../../shared/models/forms';
import {formatPhone, ValidationItem} from '../../../../shared/pipes';
import {maskPrivateData, PrivateDataMaskType} from '../../../../shared/pipes/maskPrivateData';
import {Screens} from '../../../../shared/routing';
import {DeviceSize, useDeviceSize} from '../../../../shared/theme/helpers';
import {PossibleChangeField} from '../possibleChangeField';
import {PhoneConfirmationModal} from './components/phoneConfirmationModal';

const fieldName = 'phone';

const validationItems: ValidationItem[] = [
  {
    names: fieldName,
    error: 'Обязательное поле',
    type: 'required',
  },
  {
    names: fieldName,
    error: 'Номер телефона должен состоять из 10 цифр',
    // type: 'pattern',
    // pattern: RegExps.checkPhoneNumber,
    type: 'custom',
    validator: (value) => {
      const valueLength = `${value}`.replace(/\D/g, '').length;
      return valueLength === 11;
    },
  },
];

interface Props extends EvenOddListItemContentFactoryProps {
  style?: StyleProp<ViewStyle>;
  testID?: string;
}

export const PhoneChangeField: React.FC<Props> = (props) => {
  const {isMasked} = props;
  const deviceSize = useDeviceSize();
  const navigation = useNavigation();
  const dispatch = useAppDispatch();
  const profile = useSelector(holderProfileSelector());
  const modals = useModal();

  const value = React.useMemo(() => {
    let rawValue = (profile?.mobilePhone ?? '8').replace(/\D/g, '');
    rawValue = rawValue[0] === '8' ? rawValue : `8${rawValue}`;
    rawValue = formatPhone(rawValue);

    if (isMasked) {
      rawValue = maskPrivateData(rawValue, {maskType: PrivateDataMaskType.phone});
    }

    return rawValue;
  }, [profile, isMasked]);

  const onChange = async (newValue: string) => {
    newValue = (newValue ?? '').replace(/[\D]/g, '');
    try {
      await dispatch(requestContactChange(newValue, RequestedOperationType.SetPhoneNumberConfirmation));
      dispatch(initialize(Forms.confirmPhoneForm, {phone: newValue, smsCode: ''}));
      if (deviceSize === DeviceSize.desktop) {
        modals.show({
          render(modal, methods) {
            const hideModal = () => {
              methods.remove(modal.id);
            };
            return <PhoneConfirmationModal navigation={navigation as any} onClose={hideModal} />;
          },
        });
      } else {
        navigation.navigate(Screens.ProfileUserPhoneConfirmation);
      }
    } catch (err: any) {
      let errorText = err.data?.[0]?.message || err.message || 'Ошибка. Попробуйте позже';
      console.log('error', errorText);
      // TODO: this is not working!!!
      // JUST COMMENT NOW
      // throw new SubmissionError({
      //   [fieldName]: new FormValidationError(errorText, true),
      // } as FormErrors<any, FormValidationError>);
    }
  };

  return (
    <PossibleChangeField
      testID={props.testID}
      type={fieldName}
      value={value}
      onChange={onChange}
      validationItems={validationItems}
      mask={InputMaskTypes.tel}
      {...props}
      isMasked
    />
  );
};
